angular.module('bmsApp.trugreen.quote').factory('TGAnalysisSvc', function ($q,
																		 CRUDSvc) {

	return {
		options: function (params) {
			return CRUDSvc.get('api/trugreen/analysis/options', params);
		}
	};

});
